<template>
  <div class="activateContainer">
    <div v-if="tweenStarted" ref="container" class="leaves">
      <div
        class="dot"
        :class="iconType"
        v-for="(dot, index) in total"
        :key="index"
      >
        {{ startTween(index) }}
      </div>
    </div>
    <button @click="popMystery" class="popIcon">
      <img :class="useCase" :src="image" />
    </button>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  data() {
    return {
      total: 25,
      w: window.innerWidth,
      h: window.innerHeight,
      tweenStarted: false,
    };
  },
  props: {
    icon: String,
    iconType: String,
    useCase: String,
    closed: Boolean,
    image: String,
  },
  methods: {
    startTween(index) {
      this.$nextTick(function () {
        let childTween = this.$refs.container.children[index];
        gsap.set(childTween, {
          x: this.R(0, this.w),
          y: this.R(-200, -150),
          z: this.R(-200, 200),
        });
        this.animm(childTween);
      });
    },
    animm(elm) {
      gsap.to(elm, this.R(6, 15), {
        y: this.h + 100,
        ease: gsap.easeNone,
        repeat: -1,
        delay: -15,
      });
      gsap.to(elm, this.R(4, 8), {
        x: "+=100",
        rotationZ: this.R(0, 90),
        repeat: -1,
        yoyo: true,
        ease: gsap.easeInOut,
      });
      gsap.to(elm, this.R(2, 8), {
        rotationX: this.R(0, 0),
        rotationY: this.R(0, 0),
        repeat: -1,
        yoyo: true,
        ease: gsap.easeInOut,
        delay: -5,
      });
    },
    R(min, max) {
      return min + Math.random() * (max - min);
    },
    popMystery(direct) {

      if (direct == 'close') {
        this.tweenStarted = false;
        return;
      }

      if (this.useCase && (this.useCase == "nyan" || this.useCase == "dog")) {
        if (this.closed) {
          this.open(this.useCase);
        } else {
          this.close(this.useCase);
        }
      }

      if (this.useCase == "nyan") {
        return;
      }

      /* a Pen by Diaco m.lotfollahi  : https://diacodesign.com */
      // var falling = true;
      if (!this.tweenStarted) {
        this.tweenStarted = true;
        this.$nextTick(function () {
          let container = this.$refs.container;
          gsap.set(container, { perspective: 600 });
        });
      } else {
        this.tweenStarted = false;
      }
      // TweenLite.set("img", { xPercent: "-50%", yPercent: "-50%" });
    },
    open(useCase) {
      this.$emit("open", useCase);
    },
    close(useCase) {
      this.$emit("close", useCase);
    },
  },
};
</script>

<style scoped>
.leaves {
  z-index: 9999;
  position: absolute;
  left: 0;
  top: 0;
}
.dot {
  width: 35px;
  height: 35px;
  position: absolute;
}

.unicorn {
  background: url(https://ik.imagekit.io/elysiumone/circle-cropped_NOWmFBNV-r.png);
  background-size: 100% 100%;
}

.yoko {
  background: url(https://ik.imagekit.io/elysiumone/image-removebg-preview__9__qlMBGAIWk4.png);
  background-size: 100% 100%;
}

.rocket {
  background: url(https://ik.imagekit.io/elysiumone/image-removebg-preview__10__eody7JUrQF.png);
  background-size: 100% 100%;
}

.activateContainer {
  display: inline-block;
}

.popIcon {
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  border-radius: 360px;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
.popIcon:hover {
  opacity: 1;
}

.nyan {
  width: 34px;
  height: 34px;
}
.dog {
  width: 26px;
  height: 26px;
}

@media screen and (max-width: 520px) {
  .popIcon {
    font-size: 21px;
    margin-right: 5px;
    padding: 0px;
  }
}
</style>